<one-table>

  <one-table-header>
    
    <div one-table-center-content>
      <mat-form-field 
        oneSearchField
        oneSearchFieldBorder="rounded"
        oneSearchFieldAppearance="outline"
        oneSearchFieldSize="slim"
      >
        
        <mat-icon matPrefix> search </mat-icon>
        
        <input matInput placeholder="Search" [formControl]="searchBox" (keyup)="searchText($event.target.value)"/>
        
        <button *ngIf="searchBox.value" one-icon-button-flat mat-flat-button matSuffix (click)="searchBox.setValue(''); searchText('')">
          <mat-icon>clear</mat-icon>
        </button>
      
      </mat-form-field>
    </div>
    
  </one-table-header>

  <one-table-content class="email-table">

    <mat-table [dataSource]="dataSource"  matSort mat-paginator>

      <ng-container matColumnDef="Id">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Account Id</mat-header-cell>
        <mat-cell *matCellDef="let element" class="truncate-text" [title]="element.CustomerId">{{ element.CustomerId }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Account Name</mat-header-cell>
        <mat-cell *matCellDef="let element" class="truncate-text" [title]="element.CustomerName">{{ element.CustomerName }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Country">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
        <mat-cell *matCellDef="let element" class="truncate-text" [title]="element.Country">{{ element.Country }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Email">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
        <mat-cell *matCellDef="let element" class="truncate-text" [title]="element.CustomerContactEmail">{{ element.CustomerContactEmail }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Date">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Date</mat-header-cell>
        <mat-cell *matCellDef="let element" class="truncate-text" [title]="element.Date">{{ element.Date }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Resend">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Resend</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-chip *ngIf="element.IsResend === true" style="background-color: #ffb6c1; font-weight: bold;" [title]="'Yes'" class="chip truncate-text" oneChip oneChipAppearance="outline">
            Yes
          </mat-chip>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let element" [title]="element.DeliveryStatus" style="display: flex; justify-content: space-between;">
          <mat-chip [ngClass]="{ deliveredColor: element.DeliveryStatus === 'Delivered', failedColor: element.DeliveryStatus === 'Failed' }" class="chip truncate-text" oneChip oneChipAppearance="outline">
            {{ element.DeliveryStatus }}
          </mat-chip>
          <mat-chip style="border:0px; background:none;"><i class="one-icons" (click)="emailDetails(element)">arrow_right</i></mat-chip> 
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="emailDetails(row)"></mat-row>

    </mat-table>

    <!-- No Data State -->
    <div *ngIf="dataSource.data.length === 0 || dataSource.filteredData.length === 0" class="no-data-container">
      <p *ngIf="dataSource.data.length === 0">No data found</p>
      <p *ngIf="dataSource.data.length > 0 && dataSource.filteredData.length === 0">No search results found</p>
    </div>

  </one-table-content>

  <one-table-content class="pagination">
    <mat-paginator 
      [pageSizeOptions]="[10, 25, 50, 100, 250, 500]" 
      [pageSize]="25"
      showFirstLastButtons>
    </mat-paginator>
  </one-table-content>

</one-table>